
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refundpolicy",
      function () {
        return require("private-next-pages/refundpolicy/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refundpolicy"])
      });
    }
  